import React from "react";

import { FlowCanvas } from "./FlowCanvas";
import { StepInspector } from "./StepInspector";

import type { FlowDraftState } from "../hooks/useFlowDraft";
import type { Agent } from "@/shared/types";

/* The Flow tab: the canvas, and beside it (under it when narrow) the open step. */
export function FlowEditor({ agent, flow }: {
  agent: Agent;
  flow: FlowDraftState;
}) {
  const { steps, selected } = flow;
  const index = steps.findIndex((s) => s.uid === selected);
  const step = index >= 0 ? steps[index] : null;

  return (
    <div className="flex flex-wrap items-start gap-5">
      <FlowCanvas
        steps={steps}
        selected={selected}
        agentName={agent.name}
        onSelect={flow.select}
        onEdit={flow.edit}
        onRemove={flow.remove}
      />
      <StepInspector
        step={step}
        index={index}
        onChange={(next) => flow.change(next.uid, () => next)}
        onRemove={() => step && flow.remove(step.uid)}
      />
    </div>
  );
}
